// extracted by mini-css-extract-plugin
export default {"Emoji":"bbi_a bhj_i bhj_q bhj_j"};